'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const BASE_I18N_KEY = 'learningCenter.practicalExercise.retryModal';
const RetakePracticalExerciseModal = ({
  onConfirm,
  onReject
}) => /*#__PURE__*/_jsx(UIConfirmModal, {
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "practical-exercise-retake-modal-ok",
    message: `${BASE_I18N_KEY}.confirmLabel`
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.description`
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.message`
  }),
  onConfirm: onConfirm,
  onReject: onReject,
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.rejectLabel`
  })
});
RetakePracticalExerciseModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default RetakePracticalExerciseModal;